import { Injectable } from '@angular/core';
import { PaymentPageLinkCreate } from '../../dtos/payment-page/payment-page-link-create';
import { PaymentPageLinkUpdate } from '../../dtos/payment-page/payment-page-link-update';
import { PaymentPageLinkData } from '../../interfaces/payment-page/payment-page-link-data';

@Injectable({
  providedIn: 'root'
})
export class PaymentPageLinkMapper {

  constructor() { }

  /**
   * Remove id, link and buttonHtml by destructing
   * @param data
   */
  mapToCreate(data: PaymentPageLinkData): PaymentPageLinkCreate {
    const {
      id,
      link,
      buttonHtmlCode,
      ...createData
    } = data;
    return createData;
  }

  /**
   * Remove link and buttonHtml by destructing
   * @param data
   */
  mapToUpdate(data: PaymentPageLinkData): PaymentPageLinkUpdate {
    const {
      link,
      buttonHtmlCode,
      ...updateData
    } = data;
    return updateData;
  }
}
